module.exports = __webpack_public_path__ + "img/quality-01-landscape.4b43cc6f.jpg";